// extracted by mini-css-extract-plugin
export var phone = "_30-0";